<template>
  <div>
    <v-combobox
      dense
      v-model="selectedTag"
      :items="tagsTypeList"
      :label="$t('tags')"
      :item-text="resolveTagText"
      item-value="tagName"
      color="buttons"
      item-color="buttons"
      solo
      @update:search-input="debouncedSelector($event)"
      class="widget-tag-component"
      :filter="filterTags"
      >
        <template v-slot:item="{ index, item }">
          <EMTagDisplay
            :tagName="item.tagName"
            :tagAlias="item.tagAlias"
            :key="index">
          </EMTagDisplay>
        </template>
      </v-combobox>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import customTagFilter from '../Widgets/utils/EMCustomFilterUtils';
import EMTagDisplay from '../common/EMTagDisplay.vue';

export default {
  components: {
    EMTagDisplay,
  },
  data() {
    return {
      tagsTypeList: [],
      selectedTag: {},
    };
  },
  props: {
    tag: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getAllTags() {
      this.tagsTypeList = this.getTagsList;
    },
    updateTagValue(value) {
      let tag = {};
      tag = this.getTagsList.find(
        (item) => item.tagName === value || item.tagAlias === value,
      );

      this.$emit('updateTagValue', tag);
    },
    filterTags(item, queryText) {
      return customTagFilter(item, queryText, this.getIsTechnicalTagLabel);
    },
  },
  name: 'EMTagSelect',
  computed: {
    ...mapGetters(['getTagsList', 'getIsTechnicalTagLabel', 'resolveTagText']),
  },
  created() {
    this.debouncedSelector = _.debounce(this.updateTagValue, 500);
  },
  mounted() {
    this.getAllTags();
    this.selectedTag = !this.getIsTechnicalTagLabel && this.tag.alias
      ? this.tag.alias : this.tag.name;
  },
  watch: {
    tag(newValue) {
      this.selectedTag = !this.getIsTechnicalTagLabel && newValue.alias
        ? newValue.alias : newValue.name;
    },
  },
};
</script>

<style>
.widget-tag-component .v-text-field__details{
    display:none;
}
</style>
